import CHIPS_KEYBOARD_NAV from "./_chips-keyboardnav.js";
export default class {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPSMENU";
		this.init();
	}

	init() {
		this.bindEvents(true);
	}

	bindEvents(bindDirection) {
		let kbNav = CHIPS_KEYBOARD_NAV.init();

		this.menuToggle = document.querySelector(".menu-toggle");
		this.elBody = document.querySelector("body");

		this.menuToggle.addEventListener(
			"click",
			() => {
				if (this.elBody.classList.contains("menu-on")) {
					this.elBody.classList.remove("menu-on");
				} else {
					this.elBody.classList.add("menu-on", "menu-ani");
				}
			},
			false
		);

		document.querySelector(".nav-bg").addEventListener(
			"click",
			() => {
				this.elBody.classList.remove("menu-on");
			},
			false
		);
		$(".nav-bg").on("click", function () {
			$("body").removeClass("menu-on");
		});
	}
	destroy() {
		this.bindEvents(false);
	}
}
